import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { ModalModule } from "ngx-bootstrap/modal";

import { SimCardsComponent } from "./simcards.component";
import { SimCardsService, SimCardConfigService, ISimCardConfigService } from "./simcards.service";
import { TranslateModule } from "@ngx-translate/core";
import { OAuthModule } from "@impacgroup/angular-oauth-base";
import { Route, RouterModule } from "@angular/router";
import { SimCardsMainComponent } from "./simcards.main.component";
import { SimCardDetailComponent } from "./simcarddetail.component";

@NgModule({
    declarations: [SimCardsMainComponent, SimCardsComponent, SimCardDetailComponent],
    imports: [CommonModule, RouterModule, FormsModule, ModalModule, TranslateModule, OAuthModule, MatTableModule, MatPaginatorModule, MatSortModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule],
    exports: [],
    providers: []
})
export class SimCardsModule {
    static forRoot(simCardConfig: ISimCardConfigService): ModuleWithProviders<SimCardsModule> {
        // returns the services as singletons throughout the app (for lazy loading purposes)
        return {
            ngModule: SimCardsModule,
            providers: [
                SimCardsService,
                {
                    provide: SimCardConfigService,
                    useValue: simCardConfig
                }
            ]
        };
    }

    static getRoutes(): Route[] {
        return [
            {
                path: "",
                component: SimCardsMainComponent,
                children: [
                    {
                        path: "",
                        component: SimCardsComponent
                    },
                    {
                        path: ":id",
                        component: SimCardDetailComponent
                    }
                ]
            }
        ];
    }
}
